import { useMemo } from 'react'

import { useWindowSize } from 'src/shared/hooks/use-window-size'

import { DirectionArrowShort } from '../../assets/direction-arrow-short'
import { statesMap } from '../../schemas/states'

import Nearby from './assets/nearby.png'

type PublicUserSeparatorProps = {
  city: string
  state: string
  isEmptyArea: boolean
  isEndOfAllResults?: boolean
}

const PublicUserSeparator = ({ city, state, isEmptyArea, isEndOfAllResults }: PublicUserSeparatorProps) => {
  const { width } = useWindowSize()
  city = city || 'this area'

  const title = useMemo(() => {
    if (isEmptyArea) {
      return `There's no one in ${city}!`
    }

    if (isEndOfAllResults) {
      return `That's everyone nearby!`
    }

    return `That's everyone in ${city}!`
  }, [city, isEmptyArea, isEndOfAllResults])

  const subtitle = useMemo(() => {
    if (isEndOfAllResults) {
      if (state && statesMap[state]) {
        return `Here are some other professionals licensed in ${statesMap[state]?.label}`
      } else {
        return `Here are some other professionals licensed nearby`
      }
    }

    return `We found these top professionals in neighboring areas`
  }, [isEndOfAllResults, state])

  if (width < 768) {
    return (
      <div className="flex flex-col justify-start gap-[7px] rounded-[20px] bg-primary p-[25px] pt-[20px] xs:px-6 xs:py-7">
        <h1 className="text-[22px] font-bold leading-[125%] tracking-[-3%] text-white xs:max-w-[240px] xs:text-[26px]">
          {title}
        </h1>
        <div className="flex w-full flex-row items-center justify-between">
          <p className="text-[14px] font-semibold leading-[135%] tracking-[-3%] text-white/75 xs:max-w-[300px] xs:text-[15px]">
            {subtitle}
          </p>
          <DirectionArrowShort className="size-[22px] w-max rotate-90 text-white" />
        </div>
      </div>
    )
  }

  return (
    <div className="relative flex h-full flex-col items-center justify-center gap-7 overflow-hidden rounded-[20px] bg-primary p-4 leading-[135%] tracking-[-3%] shadow-lg @container">
      <img src={Nearby} alt={title} className="w-[150px] scale-150 object-contain" />
      <h1 className="text-center font-bold leading-[135%] tracking-[-3%] text-white @xs:px-7 @sm:px-12 md:text-[30px]">
        {title}
      </h1>
      <div className="flex flex-col items-center gap-4 @xs:px-7 @sm:px-12">
        <p className="text-center font-semibold leading-[135%] tracking-[-3%] text-white md:text-[16px]">{subtitle}</p>
        <DirectionArrowShort size={35} className="text-white" />
      </div>
    </div>
  )
}

export default PublicUserSeparator
